import { Component, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

/*  HIBAKERESÉS – vevő/szállító főkönyv–analitika egyeztetés.
 *
 *  Két nézet egy képernyőn:
 *   – V/SZ ANALITIKA: főkönyvi számla + partner bontásban a főkönyv és az analitika forgalma,
 *     a pénzügyileg rendezetlen összeg és az ELTÉRÉS (a nyitóra külön is). Ha egy partnernél
 *     nulla az eltérés, ott a két nyilvántartás egyezik.
 *   – HIBALISTA: konkrét tételek, amin javítani lehet – és amit a gép magától helyre tud tenni,
 *     arra gomb is van (pl. a hiányzó nyitott tétel pótlása a könyvelésből).
 */
@Component({
  selector: 'app-naplo-egyeztetes',
  templateUrl: './egyeztetes.component.html',
  styleUrls: ['../naplo-shared.scss', './egyeztetes.component.scss'],
})
export class EgyeztetesComponent implements OnInit {
  nezet: 'vsz' | 'hibak' = 'vsz';
  tipus: '' | 'vevo' | 'szallito' = '';
  csakElteres = false;
  vsz: any = null;
  hibaLista: any = null;
  fut = false;

  constructor(private naplo: NaploService, private toast: ToastController, private alert: AlertController) {}

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    await this.betolt();
  }

  private ut(mi: string) {
    const p = new URLSearchParams({ ev: String(this.aktiv.ev) });
    if (mi === 'vsz' && this.tipus) p.set('tipus', this.tipus);
    return `/api/naplo-egyeztetes/${mi}/${this.aktiv.ugyfelId}?${p.toString()}`;
  }

  async betolt() {
    if (!this.aktiv.ugyfelId) { this.vsz = null; this.hibaLista = null; return; }
    this.fut = true;
    try {
      if (this.nezet === 'vsz') this.vsz = await this.naplo.getAbs(this.ut('vsz'));
      else this.hibaLista = await this.naplo.getAbs(this.ut('hibak'));
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült lekérni az egyeztetést.'); }
    finally { this.fut = false; }
  }

  async nezetValt(n: 'vsz' | 'hibak') { this.nezet = n; await this.betolt(); }

  get sorok(): any[] {
    const s = this.vsz?.sorok || [];
    return this.csakElteres ? s.filter((r: any) => Math.abs(r.elteres) > 0.5 || Math.abs(r.nyito_elteres) > 0.5) : s;
  }
  rendben(r: any) { return Math.abs(r.elteres) <= 0.5 && Math.abs(r.nyito_elteres) <= 0.5; }

  hibaCim(t: string) { return this.hibaLista?.leirasok?.[t] || t; }
  /** A hibafajta rövid címkéje a fejlécbe (a leírás első mondata). */
  hibaRovid(t: unknown) { return String(this.hibaCim(String(t))).split('.')[0]; }
  javitasCim(m: string) {
    return ({ feladas: 'Pótlás az analitikába', osszeg_igazitas: 'Összeg igazítása',
      torles: 'Tétel törlése', ujraszamol: 'Újraszámolás' } as any)[m] || m;
  }

  /** Egy talált hiba javítása – csak arra a tételre hat, amire a lista javítást ajánl. */
  async javit(h: any) {
    if (!h?.javithato) return;
    const a = await this.alert.create({
      header: this.javitasCim(h.javithato),
      message: `${h.bizonylatszam || ''} ${h.partner ? '– ' + h.partner : ''}<br><br>${this.hibaCim(h.tipus)}`,
      buttons: ['Mégse', { text: 'Javítás', handler: () => this.javitFut(h) }],
    });
    await a.present();
  }
  private async javitFut(h: any) {
    try {
      const r: any = await this.naplo.postAbs(`/api/naplo-egyeztetes/javitas/${this.aktiv.ugyfelId}?ev=${this.aktiv.ev}`,
        { muvelet: h.javithato, id: h.id });
      this.ok(r?.uzenet || 'Javítva.');
      await this.betolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A javítás nem sikerült.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2200, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3600, color: 'danger' })).present(); }
}
